import React, { Component } from 'react'
import { Task } from '../types'

export interface Props {
  task: Task
}
export default class Mileage extends Component<Props> {
  render() {
    const {
      task: {
        vehicle: { mileage },
      },
    } = this.props
    return (
      <div>
        <div className="task-registration__col2">
          <div className="task-registration__info-header">
            <div className="task-registration__info-header__row">Mileage</div>
          </div>
          <div className="task-registration__info-block">
            <div className="task-registration__info-block__row">
              {mileage ? mileage.toLocaleString() : 'N/A'}
            </div>
          </div>
        </div>
      </div>
    )
  }
}
